var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "hasPermi",
              rawName: "v-hasPermi",
              value: ["platform:tracking:statistics:list"],
              expression: "['platform:tracking:statistics:list']",
            },
          ],
          staticClass: "ivu-mt",
          attrs: { bordered: false, shadow: "never" },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: "",
                    size: "small",
                    "label-position": "right",
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择日期：" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: { change: _vm.handleQuery },
                        model: {
                          value: _vm.queryParams.dateRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "dateRange", $$v)
                          },
                          expression: "queryParams.dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品ID：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入商品ID", clearable: "" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleQuery($event)
                          },
                        },
                        model: {
                          value: _vm.queryParams.productId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryParams,
                              "productId",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "queryParams.productId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "所属应用：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "请选择" },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.source,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "source", $$v)
                            },
                            expression: "queryParams.source",
                          },
                        },
                        _vm._l(_vm.sourceMap, function (label, key) {
                          return _c("el-option", {
                            key: key,
                            attrs: { label: label, value: key },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "来源：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "请选择" },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.userSource,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "userSource", $$v)
                            },
                            expression: "queryParams.userSource",
                          },
                        },
                        _vm._l(_vm.userSourceMap, function (label, key) {
                          return _c("el-option", {
                            key: key,
                            attrs: { label: label, value: key },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["platform:tracking:statistics:list"],
                              expression:
                                "['platform:tracking:statistics:list']",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.handleQuery },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["platform:tracking:statistics:list"],
                              expression:
                                "['platform:tracking:statistics:list']",
                            },
                          ],
                          on: { click: _vm.resetQuery },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "table-card mt14",
          attrs: { "body-style": { padding: "20px" } },
        },
        [
          _c(
            "el-table",
            {
              ref: "summaryTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.summaryList,
                size: "small",
                border: "",
                "show-summary": "",
                "summary-method": _vm.getSummaries,
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "source", label: "所属应用", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(" " + _vm._s(_vm.sourceMap[row.source]) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "uv", label: "UV", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "一个用户在当天24小时内多次访问标记为1",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("UV "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "orderCount", label: "订单数", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "用户点击提交一次订单记录一次",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("订单数 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "paidOrderCount",
                  label: "支付订单数",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content:
                                "用户支付成功记录一次（退款订单也包含在内）",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("支付订单数 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "orderRate", label: "订单率", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "(支付订单数/UV) *100%",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("订单率 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.orderRate) + "% ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "payRate", label: "支付率", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "(支付订单数/订单数) *100%",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("支付率 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.payRate) + "% ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderAmount",
                  label: "订单金额",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content:
                                "商品售价*支付订单数量（退款金额也包含在内）",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("订单金额 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" ¥" + _vm._s(scope.row.orderAmount) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "paidAmount",
                  label: "支付金额",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "实际支付的金额（包含退款金额）",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("支付金额 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" ¥" + _vm._s(scope.row.paidAmount) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "cost", label: "成本", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content:
                                "商品成本*支付订单数量（退款成本也包含在内）",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("成本 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" ¥" + _vm._s(scope.row.cost) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "profit", label: "利润", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "支付金额-成本",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("利润 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" ¥" + _vm._s(scope.row.profit) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "profitPerUv", label: "坑产", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content:
                                "利润/UV，从大到小排序或者从小到大排序，默认按照UV值排序，UV数越大越靠前",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("坑产 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" ¥" + _vm._s(scope.row.profitPerUv) + " "),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "table-card mt14",
          attrs: { "body-style": { padding: "20px" } },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.orderList,
                stripe: "",
                size: "small",
                border: "",
              },
              on: { "sort-change": _vm.handleSortChange },
            },
            [
              _c(
                "template",
                { slot: "empty" },
                [_c("el-empty", { attrs: { description: "暂无数据" } })],
                1
              ),
              _c("el-table-column", {
                attrs: { prop: "source", label: "所属应用", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(" " + _vm._s(_vm.sourceMap[row.source]) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "userSource", label: "来源", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.userSourceMap[row.userSource]) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "productId",
                  label: "商品ID",
                  align: "center",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "商品名称",
                  align: "center",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "pv",
                  label: "PV",
                  align: "center",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "一个用户每浏览一次记录一次",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("PV "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "uv",
                  label: "UV",
                  align: "center",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "一个用户在当天24小时内多次访问标记为1",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("UV "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderCount",
                  label: "订单数",
                  align: "center",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "用户点击提交一次订单记录一次",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("订单数 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "paidOrderCount",
                  label: "支付订单数",
                  align: "center",
                  sortable: "custom",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content:
                                "用户支付成功记录一次（退款订单也包含在内）",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("支付订单数 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderRate",
                  label: "订单率",
                  align: "center",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "(支付订单数/UV) *100%",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("订单率 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.orderRate) + "% ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "payRate",
                  label: "支付率",
                  align: "center",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "(支付订单数/订单数) *100%",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("支付率 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.payRate) + "% ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "paidAmount",
                  label: "支付金额",
                  align: "center",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" ¥" + _vm._s(scope.row.paidAmount) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cost",
                  label: "成本",
                  align: "center",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content:
                                "商品成本*支付订单数量（退款成本也包含在内）",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("成本 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" ¥" + _vm._s(scope.row.cost) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "profit",
                  label: "利润",
                  align: "center",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "支付金额-成本",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("利润 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" ¥" + _vm._s(scope.row.profit) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "profitPerUv",
                  label: "坑产",
                  align: "center",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content:
                                "利润/UV，从大到小排序或者从小到大排序，默认按照UV值排序，UV数越大越靠前",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("坑产 "),
                              _c("i", { staticClass: "el-icon-question" }),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" ¥" + _vm._s(scope.row.profitPerUv) + " "),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: {
              background: "",
              "current-page": _vm.queryParams.page,
              "page-size": _vm.queryParams.limit,
              "page-sizes": [5, 10, 20, 30, 50],
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }